<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-birthday-cake"></i> Birthday</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->

            <div class="row row-replace add-m-b">
                <div class="col-md-4 col-6 col-p"> 
                    <input type="text" placeholder="Select Region" class="form-control">
                </div>
                <div class="col-md-3 col-6 col-p"> 
                    <button class="btn btn-success btn-sm">Search</button>
                </div>
                <div class="col-md-6 col-1 top-corner-items col-p"></div>
            </div>

            <div class="row m-t-30">
                <div class="col-12">
                       <div class="table-responsive">
                           <table class="table">
                               <tr class="bg-primary text-white">
                                  <th>Sr No.</th>
                                  <th>Employee Id</th>
                                  <th>Name</th>
                                  <th>Date of Birth</th>
                                  <th>Mobile No</th>
                                  <th>Email</th>
                                  <th>Site Name</th>
                                  <th>Region</th>
                                  <th>Location</th>
                               </tr>
                               
                           </table>
                        </div>
                   </div>
            </div>

            
             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

